import { useInstantSearchContext, useRSCContext } from 'react-instantsearch-core';
export function TriggerSearch() {
  var _waitForResultsRef$cu;
  var instantsearch = useInstantSearchContext();
  var waitForResultsRef = useRSCContext();
  if ((waitForResultsRef === null || waitForResultsRef === void 0 ? void 0 : (_waitForResultsRef$cu = waitForResultsRef.current) === null || _waitForResultsRef$cu === void 0 ? void 0 : _waitForResultsRef$cu.status) === 'pending') {
    var _instantsearch$mainHe;
    (_instantsearch$mainHe = instantsearch.mainHelper) === null || _instantsearch$mainHe === void 0 ? void 0 : _instantsearch$mainHe.searchOnlyWithDerivedHelpers();
  }
  return null;
}